import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, number, object, string } from "yup";
import { CancelOrderFormFormValue } from "src/models/OfflineOrder.model";
import {
  useDeleteOfflineOrderByIdMutation,
  useGetSingleOfflineOrderDataQuery,
} from "src/services/OfflineOrderService";
import { showToast } from "src/utils/showToaster";
import useDrawer from "src/hooks/useDrawer";
import CancelOrderForm from "../Layouts/CancelOrderForm";

type Props = {
  onClose: () => void;
  selectedOrderId: string;
};

const CancelOrderFormWrapper = ({ onClose, selectedOrderId }: Props) => {
  const { drawer, isDataLoading } = useDrawer();
  const { isLoading, data } =
    useGetSingleOfflineOrderDataQuery(selectedOrderId);

  const physicalModes =
    drawer?.filter((mode: any) => mode?.type === "PHYSICAL") || [];
  // Form Initial Values
  const initialValues: CancelOrderFormFormValue = {
    reason: "",
    givenAmount: data?.data.receivedAmt || "",
    paymentMode: physicalModes?.map((mode: any) => ({
      name: mode.name,
      value: mode.value,
      quantity: "",
      type: mode.type,
      availableQuantity: mode.quantity,
    })),
  };

  // Validation Schema
  const validationSchema = object().shape({
    paymentMode: array().of(
      object().shape({
        name: string().required("Please enter name"),
        value: number().required("Please enter value"),
      })
    ),
    reason: string().required("Please enter cancel reason"),
  });

  const [cancelOrderForm] = useDeleteOfflineOrderByIdMutation();

  // Handle Submit
  const handleSubmit = (
    values: CancelOrderFormFormValue,
    { setSubmitting, resetForm }: FormikHelpers<CancelOrderFormFormValue>
  ) => {
    const cancelAmount = data?.data.receivedAmt;
    const givenAmount = Number(values.givenAmount);
    const totalModeAmount = values.paymentMode.reduce((acc, curr) => {
      return acc + (curr.quantity || 0) * (curr.value || 0);
    }, 0);
    if (totalModeAmount !== givenAmount) {
      showToast("error", "Given Amount and Note Total Amount must be equal.");
      return setSubmitting(false);
    }
    if (totalModeAmount !== cancelAmount) {
      showToast("error", "Given Amount and Order Amount must be equal.");
      return setSubmitting(false);
    }
    const formattedValues = {
      paymentMode: values?.paymentMode
        ?.filter((itm) => itm.quantity !== "")
        .map((item) => ({
          name: item?.name,
          value: item?.value,
          type: item?.type,
          quantity: Number(item?.quantity),
        })),
      reason: values?.reason,
      givenAmount: Number(values?.givenAmount),
    };
    cancelOrderForm({
      id: selectedOrderId,
      body: formattedValues,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };
 
  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
      enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CancelOrderForm
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CancelOrderFormWrapper;
